var ContractConfirmation = {
  init: function() {
    this.assign_event_handlers();
  },
  assign_event_handlers: function() {
    // set with initial values
    $('.account-training-frequency').html($('#student_training_frequency').val());
    $('.account-date-joined').html(ContractConfirmation.convert_to_short_date($('#student_date_joined').val()));
    
    $(document).on('click', '#next-option', function(e) {
      e.preventDefault();

      var payment_method = $('#payment-method option:selected').val();

      if (!ContractConfirmation.address_provided()) {
        alert('Please provide the address details.');
        $('#location-notice').text('Search or manually add the address details.');
        $('html,body').animate({scrollTop: $('#account-holder-information').offset().top},'slow');
        return false;
      } else {
        $('#confirm-contract').modal('show');
        $('#contract-student-list').html('');
        ContractConfirmation.set_account_name();
        ContractConfirmation.main_contact_details();

        if (payment_method == 'None') {
          $('.account-first-installment').html('N/A');
          $('.account-ongoing-fees').html('N/A');
          $('.account-joining-fee').html('N/A');
        } else {
          $('.account-first-installment').html(ContractConfirmation.first_installment_info());
          $('.account-ongoing-fees').html(ContractConfirmation.set_ongoing_fees_info());
          $('.account-joining-fee').html(ContractConfirmation.set_joining_fee_info());
        }

        $('.account-location').html($('#student_location_id option:selected').text());
        $('.account-date-joined').html(ContractConfirmation.convert_to_short_date($('#student_date_joined').val()));
        $('.account-training-frequency').html($('#student_training_frequency').val());
        $('.account-payment-method').html($('#payment-method option:selected').text());

        ContractConfirmation.student_list();

        // repopulate the confirmation modal details
        $('.account-address').html($('.full-location-details').text());
      }
    });

    $(document).on('click', '#confirm-contract-continue', function(e) {
      $('#confirm-contract').modal('hide');
      $('.admin-student-registration-form').trigger('submit');
    });
  },
  main_contact_details: function() {
    var email = $('#student_main_contact_email').val();
    var phone = $('#student_main_contact_mobile_phone').val();

    $('.account-email').html(email);
    $('.account-phone').html(phone);
  },
  address_provided: function() {
    if ($('.full-location-details').text() != '') {
      return true;
    } else {
      return false;
    }
  },
  student_list: function() {
    // loop cloneable-student-details-fields
    $('.student-details-fields').each(function(i, obj) {
      var student_name = $(this).find('.student-first-name').val() + ' ' + $(this).find('.student-last-name').val();
      var student_dob = ContractConfirmation.convert_to_short_date($(this).find('.student-dob').val());
      var student_email = $(this).find('.student-email').val();
      var stuent_phone = $(this).find('.student-phone').val();
      var student_first_class = 'First class ' + ContractConfirmation.convert_to_short_date($(this).find('.student-fcd').val());
      var student_pass_type = $(this).find('.pass-type').val();
      var student_membership = $(this).find('.student-membership-offer').val();
      var student_note = $(this).find('.student-note').val();

      var student_detail = '<div class="student-details col mb-2">';
      student_detail += '<p><strong>Student ' + (i + 1) + '</strong></p>';
      student_detail += '<p class="mb-0">' + student_name + '</p>';
      student_detail += '<p class="mb-0">' + ContractConfirmation.convert_to_short_date(student_dob) + '</p>';
      student_detail += '<p class="mb-0">' + student_email + '</p>';
      student_detail += '<p class="mb-0">' + stuent_phone + '</p>';
      student_detail += '<p class="mb-0">' + student_dob + '</p>';
      student_detail += '<p class="mb-0">' + student_first_class + '</p>';
      student_detail += '<p class="mb-0">' + student_pass_type + '</p>';
      student_detail += '<p class="mb-0">' + student_membership + '</p>';
      if (student_note != '') {
        student_detail += '<p>' + student_note + '</p>';
      }
      student_detail += '</div>';
      
      $('#contract-student-list').append(student_detail);
    })
  },
  set_ongoing_fees_info: function() {
    var installment_amount = $('#student_total_instalment_amount').val();
    var frequency = $('#student_payment_frequency option:selected').text();

    return ContractConfirmation.currency_symbol() + parseFloat(installment_amount).toFixed(2) + ' ' + frequency;
  },
  first_installment_info: function() {
    var admin_fee = $('#student_account_setup_fee').val();
    var first_installment_fee = parseFloat($('#student_weekly_training_fee_amount').val()); // + parseFloat(admin_fee);
    var frequency = $('#student_payment_frequency option:selected').text();
    var total_first_installment_fee = 0;

    switch (frequency) {
      case 'Weekly':
        total_first_installment_fee = first_installment_fee;
        break;
      case 'Fortnightly':
        total_first_installment_fee = first_installment_fee * 2;
        break;
      case '4 Weekly':
        total_first_installment_fee = first_installment_fee * 4;
        break;
      case 'Monthly':
        total_first_installment_fee = ((first_installment_fee * 52) / 12);
        break;
    }
    total_first_installment_fee += parseFloat(admin_fee);

    return ContractConfirmation.currency_symbol() + total_first_installment_fee.toFixed(2) + ' on ' + $('#student_first_instalment_date').val();
  },
  set_joining_fee_info: function() {
    var joining_fee = $('#student_joining_fee').val();

    return ContractConfirmation.currency_symbol() + parseFloat(joining_fee).toFixed(2) + ' on ' + $('#student_joining_fee_payment_date').val();
  },
  currency_symbol: function() {
    return $('#student_country').val() == 'United Kingdom' ? '£' : '$';
  },
  convert_to_short_date: function(date) {
    if (ContractConfirmation.valid_date(date)) {
      var date = new Date(date);
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var year = date.getFullYear();

      return day + '/' + month + '/' + year;
    } else {
      return '';
    }
  },
  valid_date: function(date) {
    var date = new Date(date.replace(/-/g, '/'));
    return date instanceof Date && !isNaN(date);
  },
  set_account_name: function() {
    var first_name = $('#student_main_contact_first_name').val();
    var last_name = $('#student_main_contact_last_name').val();
    var account_name = first_name + ' ' + last_name;

    $('.account-name').html(account_name);
  }
};

document.addEventListener("turbo:load", () => {
  if ($('.admin-student-registration-form')[0]) {
    ContractConfirmation.init();
  }
});
